module.exports = __webpack_public_path__ + "media/images/banners/bg4-afd569088a61fd93bdfaac9a00245b22.png";